(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 9731:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airetro",
      function () {
        return __webpack_require__(3008);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_FloatingNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5970);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3505);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6261);
/* harmony import */ var _components_FooterBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2095);
/* harmony import */ var _components_RetroComp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6654);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2962);








const Index = ()=>{
    let scroller = react_scroll__WEBPACK_IMPORTED_MODULE_4__["default"].scroller;
    const [floatingNavStatus, setFloatingNavStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_components_FloatingNav__WEBPACK_IMPORTED_MODULE_2__.FloatingNavStatus.RETRO);
    const [prompt, setPromptText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_7__/* .NextSeo */ .PB, {
                title: "AI Generated Scrum Retrospectives",
                description: "Get inspired and have some fun generating Scrum Retrospectives with AI! Share them with your team and friends!",
                robotsProps: {
                    nosnippet: true,
                    notranslate: false,
                    noimageindex: true,
                    noarchive: false,
                    maxSnippet: -1,
                    maxImagePreview: "standard",
                    maxVideoPreview: -1
                },
                twitter: {
                    handle: "@benithors",
                    site: "@benithors",
                    cardType: "summary_large_image"
                },
                openGraph: {
                    url: "https://www.scrumify.at/airetro",
                    title: "Scrumify - AI Generated Scrum Retrospectives",
                    description: "Powering Up Software Teams.",
                    images: [
                        {
                            url: "https://res.cloudinary.com/bt101/image/upload/v1674077719/opengraph_ai_retro_ieth6r.png",
                            width: 1200,
                            height: 630,
                            alt: "Scrumify - AI Generated Scrum Retrospectives",
                            type: "image/png"
                        }
                    ],
                    site_name: "Scrumify"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FloatingNav__WEBPACK_IMPORTED_MODULE_2__["default"], {
                scroller: scroller,
                floatingNavStatus: floatingNavStatus,
                initialShowStatus: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_3__["default"], {
                scroller: scroller,
                floatingNavStatus: floatingNavStatus
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_RetroComp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                prompt: prompt,
                setPromptText: setPromptText,
                mood: 0
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FooterBar__WEBPACK_IMPORTED_MODULE_5__["default"], {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [891,260,491,126,774,888,179], function() { return __webpack_exec__(9731); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);